import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSidebar } from '../../contexts/SidebarContext';
import Sidebar from '../../components/ui/Sidebar';
import TopBar from '../../components/ui/TopBar';
import Breadcrumb from '../../components/ui/Breadcrumb';
import CrmStudioSettingsForm from './CrmStudioSettingsForm';

const AdminIntegrationsPage = () => {
  const { t } = useTranslation();
  const { isCollapsed, toggleSidebar } = useSidebar();

  const breadcrumbItems = [
    { label: t('sidebar.nav.dashboard'), path: '/dashboard', icon: 'LayoutDashboard' },
    {
      label: t('sidebar.nav.administration.integrations'),
      path: '/admin/integrations',
      icon: 'Plug',
    },
  ];

  return (
    <div className="flex h-screen bg-background overflow-hidden">
      <Sidebar isCollapsed={isCollapsed} onToggle={toggleSidebar} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <TopBar sidebarCollapsed={isCollapsed} onSidebarToggle={toggleSidebar} />
        <main className={`main-content ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
          <div className="container mx-auto px-4 py-6 space-y-6 max-w-3xl">
            <Breadcrumb items={breadcrumbItems} />
            <div>
              <h1 className="text-3xl font-bold text-foreground">
                {t('sidebar.nav.administration.integrations')}
              </h1>
              <p className="text-muted-foreground mt-1">
                {t('adminIntegrations.pageDescription')}
              </p>
            </div>

            <div className="bg-card border border-border rounded-lg overflow-visible">
              <CrmStudioSettingsForm />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminIntegrationsPage;
